module.exports = __webpack_public_path__ + "static/media/mentor1.040f02de.jpg";